// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Certificate_wrapper_TPEWO","input":"Certificate_input_2WnZo","error":"Certificate_error_3Uxne","button":"Certificate_button__EGVN","sent":"Certificate_sent_3Hgjg"};